import { Button } from '@/components/UI/Common/Button';
import { ROUTES } from '@/config/routes';
import { useGetApplication } from '@/queries/applications';
import { getBackUrl } from '@/utils/helpers';
import { Link, useNavigate, useParams } from 'react-router-dom';

export const ApplicationPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: application, isLoading, isError } = useGetApplication(id);

  if (isLoading) {
    return (
      <div className="w-full min-h-[calc(100dvh-64px)] bg-white flex items-center justify-center text-gray">
        Загрузка...
      </div>
    );
  }

  if (isError || !application) {
    return (
      <div className="w-full min-h-[calc(100dvh-64px)] bg-white flex flex-col items-center justify-center gap-5 px-4">
        <p className="text-lg text-[#313a4a]">Приложение не найдено</p>
        <Link to={ROUTES.HOME}>
          <Button variant="outline" size="lg" className="min-w-52">
            На главную
          </Button>
        </Link>
      </div>
    );
  }

  const iconSrc = application.upload?.path
    ? `${getBackUrl()}/uploads/${application.upload.path}`
    : '/logo-100x22-violet.svg';
  const links = application.applicationLinks ?? [];

  return (
    <div className="w-full min-h-[calc(100dvh-64px)] bg-white">
      <div className="mx-auto w-full max-w-3xl px-4 py-6 lg:px-8 lg:py-10">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mb-6 text-sm font-medium text-[#662c83] hover:opacity-75 transition"
        >
          ← Назад
        </button>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 sm:items-center">
          <img
            src={iconSrc}
            alt=""
            className="h-[74px] w-[74px] shrink-0 rounded-2xl bg-gray-200 object-cover shadow-xs"
          />
          <div className="min-w-0">
            <h1 className="text-2xl lg:text-3xl font-medium text-[#202735]">{application.title}</h1>
            {application.description && (
              <p className="mt-1.5 text-sm lg:text-base text-gray leading-relaxed">
                {application.description}
              </p>
            )}
          </div>
        </div>

        {application.link && (
          <div className="mt-8 flex flex-wrap gap-3">
            <a href={application.link} target="_blank" rel="noreferrer">
              <Button variant="primary" size="lg" className="min-w-40 sm:min-w-52">
                Открыть
              </Button>
            </a>
            <Link to={ROUTES.HOME}>
              <Button variant="outline" size="lg" className="min-w-40 sm:min-w-52">
                На главную
              </Button>
            </Link>
          </div>
        )}

        {!application.link && (
          <div className="mt-8">
            <Link to={ROUTES.HOME}>
              <Button variant="outline" size="lg" className="min-w-40 sm:min-w-52">
                На главную
              </Button>
            </Link>
          </div>
        )}

        {links.length > 0 && (
          <section className="mt-10">
            <h2 className="mb-3 text-lg font-medium text-[#202735]">Ссылки на документы</h2>
            <ul className="border-t border-[#e5e7eb]">
              {links.map((link) => (
                <li key={link.id} className="border-b border-[#e5e7eb]">
                  <a
                    href={link.link}
                    target="_blank"
                    rel="noreferrer"
                    className="block py-3.5 hover:bg-[#f5f1f7] transition-colors -mx-2 px-2 rounded-md"
                  >
                    <span className="font-medium text-[#662c83]">{link.title}</span>
                    {link.description && (
                      <span className="mt-0.5 block text-sm text-gray leading-snug">
                        {link.description}
                      </span>
                    )}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        )}
      </div>
    </div>
  );
};
